import Repositories from './Repositories';

export default Repositories;
